<template>
  <div>
    <modal
      name="team-incident-remove"
      :adaptive="true"
      :minHeight="650"
      :maxHeight="auto"
      :scrollable="true"
    >
      <div class="text-center mt-4">
        <h6 class="text-gray-600 text-xl font-bold">Team - {{ team.name }}</h6>
      </div>
      <div style="margin: 20px">
        <FormulateForm @submit="removeIncident">
          <div class="flex flex-wrap">
            <div class="w-full xl:w-12/12 mb-12 xl:mb-0 px-2">
              <FormulateInput
                type="text"
                name="number"
                label="Number"
                outer-class="mb-4"
                input-class="border border-gray-400 rounded px-3 py-2 leading-none focus:border-green-500 outline-none border-box w-full mb-1"
                label-class="block uppercase text-gray-700 text-xs font-bold mb-2"
                disabled
                :value="incident.number"
              />
            </div>
            <div class="w-full xl:w-6/12 mb-12 xl:mb-0 px-2">
              <FormulateInput
                type="text"
                name="caller"
                label="Caller"
                outer-class="mb-4"
                input-class="border border-gray-400 rounded px-3 py-2 leading-none focus:border-green-500 outline-none border-box w-full mb-1"
                label-class="block uppercase text-gray-700 text-xs font-bold mb-2"
                disabled
                :value="incident.caller"
              />
            </div>
            <div class="w-full xl:w-6/12 mb-12 xl:mb-0 px-2">
              <FormulateInput
                type="text"
                name="executor"
                label="Executor"
                outer-class="mb-4"
                input-class="border border-gray-400 rounded px-3 py-2 leading-none focus:border-green-500 outline-none border-box w-full mb-1"
                label-class="block uppercase text-gray-700 text-xs font-bold mb-2"
                disabled
                :value="incident.executor"
              />
            </div>
            <div class="w-full xl:w-6/12 mb-12 xl:mb-0 px-2">
              <FormulateInput
                type="text"
                name="Category Name"
                label="category_name"
                outer-class="mb-4"
                input-class="border border-gray-400 rounded px-3 py-2 leading-none focus:border-green-500 outline-none border-box w-full mb-1"
                label-class="block uppercase text-gray-700 text-xs font-bold mb-2"
                disabled
                :value="incident.category_name"
              />
            </div>
            <div class="w-full xl:w-6/12 mb-12 xl:mb-0 px-2">
              <FormulateInput
                type="text"
                name="state"
                label="State"
                outer-class="mb-4"
                input-class="border border-gray-400 rounded px-3 py-2 leading-none focus:border-green-500 outline-none border-box w-full mb-1"
                label-class="block uppercase text-gray-700 text-xs font-bold mb-2"
                disabled
                :value="incident.state"
              />
            </div>
            <div class="w-full xl:w-4/12 mb-12 xl:mb-0 px-2">
              <FormulateInput
                type="text"
                name="impact"
                label="Impact"
                outer-class="mb-4"
                input-class="border border-gray-400 rounded px-3 py-2 leading-none focus:border-green-500 outline-none border-box w-full mb-1"
                label-class="block uppercase text-gray-700 text-xs font-bold mb-2"
                disabled
                :value="incident.impact"
              />
            </div>
            <div class="w-full xl:w-4/12 mb-12 xl:mb-0 px-2">
              <FormulateInput
                type="text"
                name="urgency"
                label="Urgency"
                outer-class="mb-4"
                input-class="border border-gray-400 rounded px-3 py-2 leading-none focus:border-green-500 outline-none border-box w-full mb-1"
                label-class="block uppercase text-gray-700 text-xs font-bold mb-2"
                disabled
                :value="incident.urgency"
              />
            </div>
            <div class="w-full xl:w-4/12 mb-12 xl:mb-0 px-2">
              <FormulateInput
                type="text"
                name="priority"
                label="Priority"
                outer-class="mb-4"
                input-class="border border-gray-400 rounded px-3 py-2 leading-none focus:border-green-500 outline-none border-box w-full mb-1"
                label-class="block uppercase text-gray-700 text-xs font-bold mb-2"
                disabled
                :value="incident.priority"
              />
            </div>
            <div class="w-full xl:w-12/12 mb-12 xl:mb-0 px-2">
              <FormulateInput
                type="text"
                name="short_description"
                label="Short Description"
                outer-class="mb-4"
                input-class="border border-gray-400 rounded px-3 py-2 leading-none focus:border-green-500 outline-none border-box w-full mb-1"
                label-class="block uppercase text-gray-700 text-xs font-bold mb-2"
                disabled
                :value="incident.short_description"
              />
            </div>
            <div class="w-full xl:w-12/12 mb-12 xl:mb-0 px-2">
              <FormulateInput
                type="text"
                name="description"
                label="Description"
                outer-class="mb-4"
                input-class="border border-gray-400 rounded px-3 py-2 leading-none focus:border-green-500 outline-none border-box w-full mb-1"
                label-class="block uppercase text-gray-700 text-xs font-bold mb-2"
                disabled
                :value="incident.description"
              />
            </div>
            <div class="w-full xl:w-12/12 xl:mb-0 px-2 mt-5">
              <FormulateInput
                input-class="px-4 py-2 w-full rounded bg-blue-500 text-white hover:bg-blue-700"
                type="submit"
                name="Remove Incident"
              />
            </div>
          </div>
        </FormulateForm>
      </div>
    </modal>
  </div>
</template>
<script>
/* 
  Class: ModalTeamIncidentRemove
  Description: This class representing a team incident remove modal.
*/

/* Imports */
import TeamService from "@/services/team.service";
/* /Imports/ */

export default {
  /* 
    Define data with custom incidents state values. 
  */
  data() {
    return {
      incidents: [],
    };
  },

  /* 
    Define props from which we got team and incident data. 
  */
  props: {
    team: null,
    incident: null
  },

  /* 
    Define methods for separate different logic. 
  */
  methods: {
    /* 
      Call TeaemService class to remove selected incident from the certain team.
    */
    removeIncident() {
      var data = { incidents: [this.incident.id]};

      TeamService.removeIncident(this.team.id, data).then(() => {
        location.reload();
      });
    },
  },
};
</script>
